"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SCAN_SCORING_PARAMETERS = void 0;
var client_1 = require("@apollo/client");
exports.GET_SCAN_SCORING_PARAMETERS = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetScanScoringParameters {\n    scanScoringWeights {\n      scanSuccessThreshold\n      scanSuccessFacingScoreWeight\n      scanSuccessPointCloudScoreWeight\n    }\n  }\n"], ["\n  query GetScanScoringParameters {\n    scanScoringWeights {\n      scanSuccessThreshold\n      scanSuccessFacingScoreWeight\n      scanSuccessPointCloudScoreWeight\n    }\n  }\n"])));
var templateObject_1;
